import { getCurrentTheme } from './config';

const actions = {
  CHANGE_THEME: 'CHANGE_THEME',
  SWITCH_ACTIVATION: 'SWITCH_ACTIVATION',
  
  switchActivation: () => ({
    type: actions.SWITCH_ACTIVATION,
  }),
  
  changeTheme: () => ({
    type: actions.CHANGE_THEME,
    theme: getCurrentTheme()
  })
};

export default actions;
